<div class="modal-header">
  <span class="modal-header__title">{{label}}</span>
</div>

<div class="modal-content">
  <ion-spinner *ngIf="loading"
               class="reason-selection__spinner"
               name="crescent"></ion-spinner>

  <ion-list *ngIf="!loading && (reasons.length || !multiSelect)"
            class="ion-no-padding">
    <ion-radio-group *ngIf="!multiSelect; else checkboxList"
                     [value]="singleSelectedId"
                     (ionChange)="onRadioChange($event)">
      <ion-item *ngFor="let reason of reasons"
                mode="md"
                lines="none"
                class="bordered-item">
        <ion-radio slot="start"
                   class="ion-no-margin ion-margin-end"
                   [value]="reason.id"></ion-radio>
        <ion-label>{{reason.name}}</ion-label>
      </ion-item>

    </ion-radio-group>

    <!-- Deliberately OUTSIDE ion-radio-group: the group attaches an
         unconditional click/keydown listener on its own host that reacts to
         ANY descendant interaction, which fights a nested text input (typing
         was re-triggering it and deselecting "Other"). Checked state and
         exclusivity with the real reasons are both just selectedReasonIds,
         so staying outside the group loses nothing. -->
    <div *ngIf="!multiSelect"
         class="bordered-item bordered-item--other"
         (click)="onSelectOther()">
      <!-- ion-radio normally gets its checked visual from an ion-radio-group
           ancestor watching its value; standalone, [checked] alone doesn't
           reliably drive it (Ionic Angular's IonRadio wrapper doesn't even
           declare `checked` as an @Input), so force the host class its
           checked-state CSS is actually keyed on. -->
      <ion-radio class="ion-no-margin ion-margin-end"
                 [class.radio-checked]="isOtherSelected"></ion-radio>
      <div class="other-reason">
        <span class="other-reason__label">{{ 'pos.reasonSelection.other' | transloco }}</span>
        <ion-input *ngIf="isOtherSelected"
                   #otherReasonInput
                   [(ngModel)]="otherReasonText"
                   [maxlength]="OTHER_REASON_MAX_LENGTH"
                   [placeholder]="'pos.reasonSelection.otherPlaceholder' | transloco"
                   (click)="$event.stopPropagation()"></ion-input>
      </div>
    </div>

    <ng-template #checkboxList>
      <ion-item *ngFor="let reason of reasons"
                mode="md"
                lines="none"
                class="bordered-item"
                (click)="onToggleReason(reason.id)">
        <ion-checkbox slot="start"
                      class="ion-no-margin ion-margin-end"
                      [checked]="isSelected(reason.id)"></ion-checkbox>
        <ion-label>{{reason.name}}</ion-label>
      </ion-item>
    </ng-template>
  </ion-list>

  <div *ngIf="!loading && loadError"
       class="reason-selection__empty">
    <p>{{ 'pos.reasonSelection.loadError' | transloco }}</p>
    <ion-button mode="md"
                fill="outline"
                color="dark"
                debounce-click
                [debounceTime]="0"
                (debounceClick)="fetchReasons()">{{ 'common.retry' | transloco }}</ion-button>
  </div>

  <p *ngIf="!loading && !loadError && multiSelect && !reasons.length"
     class="reason-selection__empty">{{ 'pos.reasonSelection.noReasonsAvailable' | transloco }}</p>
</div>

<div class="footer-buttons">
  <ion-button color="dark"
              debounce-click
              [debounceTime]="0"
              (debounceClick)="onCloseModal()">{{ 'common.cancel' | transloco }}</ion-button>
  <ion-button color="moonstone"
              [disabled]="isConfirmDisabled"
              debounce-click
              [debounceTime]="0"
              (debounceClick)="onConfirm()">{{ 'pos.reasonSelection.confirm' | transloco }}</ion-button>
</div>
